// extracted by mini-css-extract-plugin
export default {"fade-in":"classes_fade-in__xVWd8","fadeIn":"classes_fadeIn__NFo6K"};